import type { Application, Lead } from '../../../lib/api'
import { SectionBody, SectionHeader } from './StageContextLayout'

export function PendedContext({ lead }: { lead: Lead; app?: Application | null }) {
  const isPended = lead.stage === 'pended'
  return (
    <>
      <SectionHeader color="#fef3c7">
        <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#92400e' }}>
          {isPended ? 'Pended' : 'Conditional Approval'}
        </h3>
      </SectionHeader>
      <SectionBody>
        <p style={{ fontSize: '14px', color: '#92400e', marginBottom: '12px' }}>
          {isPended
            ? 'This application requires additional information before it can proceed.'
            : 'Conditional approval received — additional documents may be required.'}
        </p>
        <p style={{ fontSize: '13px', color: '#6b7280' }}>
          A secure upload link has been generated. Share it with the merchant to collect the requested documents.
        </p>
      </SectionBody>
    </>
  )
}
